// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Cookie from '../classes/Cookie';
import Cookies from '../constants/Cookies';
import Time from '../constants/Time';
import User from '../classes/User';
import Notifications from '../constants/Notifications';

export default class CookieSwitch extends Component {
  #changeHandler: function;
  #activeOption: HTMLInputElement;
  options: Array<HTMLElement>;
  shouldNotifyUser: boolean;

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.options = Array.from(pEl.querySelectorAll('input'));

    this.#changeHandler = this.onChange.bind(this);

    this.options.forEach((option: HTMLElement) => {
      option.addEventListener(EventNames.CHANGE, this.#changeHandler);

      if (!(option instanceof HTMLInputElement) || !option.checked) return;
      this.#activeOption = option;
    });

    this.shouldNotifyUser = !!this.el.dataset.notify;

    this.addListener(Notifications.COOKIES_CHANGED, ({ value }: { value: string }) => {
      this.options.find((option: HTMLInputElement) => option.value === value).checked = true;
    });
    const cookieModal = document.getElementByRef('cookie-modal');
    if (cookieModal) {
      cookieModal.classList.remove('hidden');
    }
  }

  /**
   * Executes when one of the options is clicked
   */
  onChange(e: Event): void {
    if (e.target === this.#activeOption || !(e.target instanceof HTMLInputElement)) return;
    this.notify('changeCookieLoader');
    this.#activeOption = e.target;

    Cookie.set(Cookies.TRACKING, this.#activeOption.value, Time.YEAR_IN_SECONDS);
    this.notify(Notifications.COOKIES_CHANGED, { value: this.#activeOption.value });

    document.getElementByRef('cookie-modal')?.remove();

    if (this.shouldNotifyUser) {
      User.notifySuccess(window.store.getTranslation('tracking.update.preferences.success'));
    }

    if (this.#activeOption.value === '0') {
      window.store.sessionManager.clearAllTrackingInformation();
    }
  }

  /**
   * Destroy all event listeners
   */
  destroy(): void {
    this.options.forEach((option: HTMLElement) => option.removeEventListener(EventNames.CHANGE, this.#changeHandler));
    super.destroy();
  }
}
